import { HttpClient } from '../../httpClient'
import type {
  OpalApi,
  OpalApiResponseDocument,
  OpalApiRequestBody,
} from '../../schema'

type CreateMomentV2 = OpalApi<'CreateMomentV2', 201>

export type CreateMomentV2ResponseData = OpalApiResponseDocument<
  'CreateMomentV2',
  201
>

export type CreateMomentV2RequestBody = OpalApiRequestBody<'CreateMomentV2'>

export const createMoment: CreateMomentV2 = ({
  requestBody,
}: Parameters<CreateMomentV2>[0] = {}) => {
  return HttpClient()
    .post<CreateMomentV2ResponseData>('/moments/v2', requestBody)
    .then((res) => res.data)
}
